import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useEffect } from 'react';
import { QueryClientProvider, useQuery, useMutation, hashQueryKey } from '@tanstack/react-query';

function createReactQueryHooks(client, opts) {
    const mapQueryKey = client.mapQueryKey || ((x)=>x);
    const Context = opts?.context || /*#__PURE__*/ createContext(undefined);
    function useContext$1() {
        const ctx = useContext(Context);
        if (ctx?.queryClient === undefined) throw new Error("The rspc context has not been set. Ensure you have the <rspc.Provider> component higher up in your component tree.");
        return ctx;
    }
    function useQuery$1(keyAndInput, opts) {
        const { rspc , ...rawOpts } = opts ?? {};
        let client = rspc?.client;
        if (!client) {
            client = useContext$1().client;
        }
        return useQuery({
            queryKey: mapQueryKey(keyAndInput),
            queryFn: async ()=>{
                return await client.query(keyAndInput);
            },
            ...rawOpts
        });
    }
    function useMutation$1(key, opts) {
        const { rspc , ...rawOpts } = opts ?? {};
        let client = rspc?.client;
        if (!client) {
            client = useContext$1().client;
        }
        return useMutation(async (input)=>{
            const actualKey = Array.isArray(key) ? key[0] : key;
            return client.mutation([
                actualKey,
                input
            ]);
        }, rawOpts);
    }
    function useSubscription(keyAndInput, opts) {
        let client = opts?.rspc?.client;
        if (!client) {
            client = useContext$1().client;
        }
        const queryKey = hashQueryKey(keyAndInput);
        const enabled = opts?.enabled ?? true;
        return useEffect(()=>{
            if (!enabled) {
                return;
            }
            return client.addSubscription(keyAndInput, {
                onData: opts.onData,
                onError: opts.onError
            });
        }, [
            queryKey,
            enabled
        ]);
    }
    return {
        _rspc_def: undefined,
        Provider: ({ children , client , queryClient  })=>jsx(Context.Provider, {
                value: {
                    client,
                    queryClient
                },
                children: jsx(QueryClientProvider, {
                    client: queryClient,
                    children: children
                })
            }),
        useContext: useContext$1,
        useQuery: useQuery$1,
        // useInfiniteQuery,
        useMutation: useMutation$1,
        useSubscription
    };
}

export { createReactQueryHooks };
